import { render, staticRenderFns } from "./PassWord.vue?vue&type=template&id=a0340a44&scoped=true&"
import script from "./PassWord.vue?vue&type=script&lang=js&"
export * from "./PassWord.vue?vue&type=script&lang=js&"
import style0 from "./PassWord.vue?vue&type=style&index=0&id=a0340a44&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0340a44",
  null
  
)

export default component.exports